// Google Analytics 4, double-gated:
//  1. volto-gdpr-privacy only mounts this component while the visitor has
//     accepted the "Google Analytics" choice (config key prof_GANALYTICS).
//  2. It only initialises GA on the production host names below, so the
//     staging host new.arkusinc.com and the bare IP never send hits.
// The measurement id comes from RAZZLE_GA4_CODE (build env and compose env).
import { useEffect } from 'react';
import { useGoogleAnalytics } from 'volto-google-analytics';

export const GA_HOSTS = ['www.arkusinc.com', 'arkusinc.com'];

const gaId = () =>
  (typeof window !== 'undefined' && window.env?.RAZZLE_GA4_CODE) ||
  process.env.RAZZLE_GA4_CODE;

export const gaHostAllowed = () =>
  typeof window !== 'undefined' &&
  GA_HOSTS.includes(window.location.hostname.toLowerCase());

const dropGaCookies = () => {
  const host = window.location.hostname;
  const domains = ['', host, `.${host.replace(/^www\./, '')}`];
  document.cookie
    .split(';')
    .map((c) => c.trim().split('=')[0])
    .filter((n) => n === '_ga' || n.startsWith('_ga_') || n === '_gid')
    .forEach((n) =>
      domains.forEach((d) => {
        document.cookie = `${n}=; Max-Age=0; path=/${d ? `; domain=${d}` : ''}`;
      }),
    );
};

const ArkusAnalytics = () => {
  const id = gaId();
  const allowed = gaHostAllowed() && !!id;
  useEffect(() => {
    if (!allowed) return undefined;
    window[`ga-disable-${id}`] = false;
    return () => {
      // consent withdrawn (component unmounted): stop GA and remove its cookies
      window[`ga-disable-${id}`] = true;
      dropGaCookies();
    };
  }, [allowed, id]);
  useGoogleAnalytics(allowed);
  return null;
};

export default ArkusAnalytics;
